<template>
  <div class="mine">
    <div class="top">
      <div class="info">
        <div class="title">
          <div class="name">
            <div class="padding"></div>
            个人资料
          </div>
        </div>
        <div class="company-info">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <div class="company-avatar">
              <div class="avatar">
                <el-upload
                  class="avatar-uploader"
                  :action="$uploadFileUrl"
                  :show-file-list="false"
                  :multiple="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
					<div class="image-area" >
					  <div v-if="ruleForm.avatar">
									<img :src="$imgUrl + ruleForm.avatar" class="avatar" />
									<span>修改头像</span>
								</div >
								<div v-else>
									<img :src="require('../../assets/image/photo.jpg')" class="avatar" />
									<span>修改头像</span>
								</div>
					 </div>
                </el-upload>
              </div>
              <div class="right">
                <div class="username">{{ ruleForm.name }}</div>
                <div class="score">
                  <span>暂无评分</span>
                </div>
              </div>
            </div>
            <el-form-item label="用户名" prop="name">
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="company">
              <el-input
                v-model="ruleForm.company"
                placeholder="请输入公司名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="ruleForm.phone"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item prop="region" label="行政区划">
              <el-cascader
                :props="props"
                v-model="ruleForm.region"
                :options="regionList"
                placeholder="请选择行政区划"
                style="width: 100%"
                @change="addressChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="ruleForm.address"
                placeholder="请输入地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="公司介绍" prop="description">
              <el-input
                type="textarea"
                v-model="ruleForm.description"
                placeholder="请输入公司介绍"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')"
                >保存</el-button
              >
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="bill">
        <div class="title">
          <div class="name">
            <div class="padding"></div>
            费用统计&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: #9D9D9D;font-size: 14px">*以下统计仅统计近3个月的订单</span>
          </div>
        </div>
                  <div class="money">
                    <div class="item">
                      <div class="value">{{ datas.a1+datas.a2 }}</div>
                      <div class="key">待结算费用</div>
                    </div>
                    <div class="item">
                      <div class="value">{{ datas.a3 }}</div>
                      <div class="key">已结算费用</div>
                    </div>
                    <div class="item">
                      <div class="value">{{ datas.a4 }}</div>
                      <div class="key">已入账费用</div>
                    </div>
                  </div>
                    <div class="table" style="background-color: white">
                      <el-table :data="tableData" stripe style="width: 100%">
                        <el-table-column
                          prop="orderNo"
                          label="订单信息"
                          width="130"
                        ></el-table-column>
                          <el-table-column label="工程名称" align="center" prop="projectname" />
                        <el-table-column
                          prop="addTime"
                          label="开始时间"
                          width="180"
                        ></el-table-column>
                        <el-table-column
                          prop="advance"
                          label="订单金额"
                        ></el-table-column>
                        <el-table-column label="操作">
                          <template slot-scope="scope">
                            <div class="scope-button">
                              <div
                                class="scope-button-item scope-button-blue"
                                @click="hanldeCheck(scope.row)"
                              >
                                <i class="el-icon-search"></i>
                                查看
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                        <div
                                style="
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
        padding-bottom: 20px;
      "
                                v-if="total1 > queryParams.pageSize"
                        >
                            <el-pagination background layout="prev, pager, next,total" :total="total1" :page-size="queryParams.pageSize"
                                           @current-change="handleCurrentChange">
                            </el-pagination>
                        </div>
      </div>
<!--        <div class="money">-->
<!--          <div class="item">-->
<!--            <div class="value">{{ datas.a1+datas.a2 }}</div>-->
<!--            <div class="key">待结算费用</div>-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <div class="value">{{ datas.a3 }}</div>-->
<!--            <div class="key">已结算费用</div>-->
<!--          </div>-->
<!--          <div class="item">-->
<!--            <div class="value">{{ datas.a4 }}</div>-->
<!--            <div class="key">已入账费用</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="list">-->
<!--          <div class="tabbar">-->
<!--            <div-->
<!--              :class="'item ' + (index == categoryIndex ? 'item-select' : '')"-->
<!--              v-for="(item, index) in category"-->
<!--              :key="index"-->
<!--              @click="tabChange(index)"-->
<!--            >-->
<!--              {{ item }}-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="table">-->
<!--            <el-table :data="tableData" stripe style="width: 100%">-->
<!--              <el-table-column-->
<!--                prop="orderNo"-->
<!--                label="订单信息"-->
<!--                width="180"-->
<!--              ></el-table-column>-->
<!--              <el-table-column-->
<!--                prop="addTime"-->
<!--                label="开始时间"-->
<!--                width="180"-->
<!--              ></el-table-column>-->
<!--              <el-table-column-->
<!--                prop="advance"-->
<!--                label="订单金额"-->
<!--              ></el-table-column>-->
<!--              <el-table-column label="操作">-->
<!--                <template slot-scope="scope">-->
<!--                  <div class="scope-button">-->
<!--                    <div-->
<!--                      class="scope-button-item scope-button-blue"-->
<!--                      @click="hanldeCheck(scope.row)"-->
<!--                    >-->
<!--                      <i class="el-icon-search"></i>-->
<!--                      查看-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--            </el-table>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <div class="btm">
      <div class="title">
        <div class="name">
          <div class="padding"></div>
          资质认证
        </div>
      </div>
      <div class="box">
        <div class="item">
          <div class="key">身份认证</div>
          <div class="value">完成实名认证，享受更多服务</div>
          <div style="float: right">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="dialogTableVisible = true"
              >实名</el-button
            >
          </div>
        </div>
        <div class="item">
          <div class="key">资质认证</div>
          <div class="value">认证营业资质，开启商家服务</div>
          <div style="float: right">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="dialogTableVisible1 = true"
              >实名</el-button
            >
          </div>
        </div>
      </div>
      <!-- <div class="button"><el-button type="primary">保存</el-button></div> -->
    </div>

    <el-dialog
      title="身份证信息"
      :visible.sync="dialogTableVisible"
      width="30%"
    >
      <div class="uploadCss" style="height: 200px">
        <el-col :span="12">
          <el-upload
            class="avatar-uploader"
            :action="$uploadUrl"
            :show-file-list="false"
            :multiple="false"
            :on-success="handleAvatarSuccess1"
            :before-upload="beforeAvatarUpload"
          >
            <div class="image-area" v-if="ruleForm.identityCard">
              <img :src="$imgUrl + ruleForm.identityCard" class="avatar" />
              <span>更换</span>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
        <el-col :span="12">
          <el-upload
            class="avatar-uploader"
            :action="$uploadUrl"
            :multiple="false"
            :show-file-list="false"
            :on-success="handleAvatarSuccess2"
            :before-upload="beforeAvatarUpload"
          >
            <div class="image-area" v-if="ruleForm.identityCardOr">
              <img :src="$imgUrl + ruleForm.identityCardOr" class="avatar" />
              <span>更换</span>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </div>
      <el-button size="mini" type="primary" @click="submitForm('ruleForm')"
        >保存</el-button
      >
    </el-dialog>
    <el-dialog title="资质信息" :visible.sync="dialogTableVisible1" width="30%">
      <div class="uploadCss" style="height: 200px">
        <el-col :span="12">
          <el-upload
            class="avatar-uploader"
            :action="$uploadUrl"
            :show-file-list="false"
            :multiple="false"
            :on-success="handleAvatarSuccess3"
            :before-upload="beforeAvatarUpload"
          >
            <div class="image-area" v-if="ruleForm.tradingCertificate">
              <img
                :src="$imgUrl + ruleForm.tradingCertificate"
                class="avatar"
              />
              <span>更换</span>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </div>
      <el-button size="mini" type="primary" @click="submitForm('ruleForm')"
        >保存</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import {
    factory_userinfo,
    factory_info_update,
    electrician_info_password,
    ProvinceList,
    equOrderList,
    equOrderListS,
    equOrderListSs, staApiAll, equOrderListS070,
} from "../../http/factory/add-eme.js";
export default {
  name: "mine",
  data() {
    return {
        total1:0,
        queryParams:{
            pageNum: 1,
            pageSize: 10,
        },
      dialogTableVisible: false,
      dialogTableVisible1: false,
      info: {
        score: 4,
        forThe: 1000,
        settled: 20000,
        dispatch: 123123,
      },
      ruleForm: {
        avatar: "",
        name: "",
        company: "",
        leader: "",
        phone: "",
        address: "",
        description: "",
        region: [],
        province: "",
        city: "",
        county: "",
        identityCard: "",
        identityCardOr: "",
        tradingCertificate: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        company: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        region: [
          {
            required: true,
            message: "请选择行政区划",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入地址",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "请填写公司简介",
            trigger: "blur",
          },
        ],
      },
      category: ["待结算", "已结算", "已入账"],
      categoryIndex: 0,
      tableData: [
        {
          name: "产品名称",
          time: "2022/06/16 21:57",
          cost: 1000,
          id: 1,
        },
        {
          name: "产品名称",
          time: "2022/06/16 21:57",
          cost: 1000,
          id: 1,
        },
        {
          name: "产品名称",
          time: "2022/06/16 21:57",
          cost: 1000,
          id: 1,
        },
        {
          name: "产品名称",
          time: "2022/06/16 21:57",
          cost: 1000,
          id: 1,
        },
        {
          name: "产品名称",
          time: "2022/06/16 21:57",
          cost: 1000,
          id: 1,
        },
        {
          name: "产品名称",
          time: "2022/06/16 21:57",
          cost: 1000,
          id: 1,
        },
      ],
      total: 100,
      pageSize: 6,
      currentPage: 1,
      regionList: [],
      props: {
        label: "label",
        value: "id",
      },
      datas: {},
    };
  },
  methods: {
      handleCurrentChange(val) {
          this.queryParams.pageNum = val;
          this.getOrderList1();
      },
      getOrderList1() {
          equOrderListS070(
              this.queryParams
          ).then((res) => {
              this.tableData = res.rows;
              this.total1=res.total
          });
          // },
      },
    handleAvatarSuccess1(file) {
      this.ruleForm.identityCard = file.fileName;
    },
    handleAvatarSuccess2(file) {
      this.ruleForm.identityCardOr = file.fileName;
    },
    handleAvatarSuccess3(file) {
      this.ruleForm.tradingCertificate = file.fileName;
    },
    pageChange() {},
    handleAvatarSuccess(res) {
      if (res.code == 200) {
        this.ruleForm.avatar = res.fileName;
      }
    },
    beforeAvatarUpload() {},
    //选中地址
    addressChange(value) {
      this.ruleForm.province = value[0];
      this.ruleForm.city = value[1];
      this.ruleForm.county = value[2];
    },
    getRegion() {
      ProvinceList().then((data) => {
        this.regionList = data;
      });
    },
    getUserInfo() {
      factory_userinfo().then((res) => {
        this.ruleForm = {
          avatar: res.heading,
          name: res.name,
          company: res.companyName,
          phone: res.phone,
          address: res.address,
          description: res.introduce,
          region: [
            parseInt(res.province),
            parseInt(res.city),
            parseInt(res.county),
          ],
          province: parseInt(res.province),
          city: parseInt(res.city),
          county: parseInt(res.county),
          identityCard: res.identityCard,
          identityCardOr: res.identityCardOr,
          tradingCertificate: res.tradingCertificate,
        };
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          factory_info_update({
            heading: this.ruleForm.avatar,
            name: this.ruleForm.name,
            companyName: this.ruleForm.company,
            phone: this.ruleForm.phone,
            address: this.ruleForm.address,
            province: this.ruleForm.region[0],
            city: this.ruleForm.region[1],
            county: this.ruleForm.region[2],
            introduce: this.ruleForm.description,
            identityCard: this.ruleForm.identityCard,
            identityCardOr: this.ruleForm.identityCardOr,
            tradingCertificate: this.ruleForm.tradingCertificate,
          }).then((res) => {
            this.$message({
              message: "更新信息成功！",
              type: "success",
            });
            this.dialogTableVisible = false;
            this.dialogTableVisible1 = false;
          });
        }
      });
    },
    //重置
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    //订单切换
    tabChange(index) {
      this.categoryIndex = index;
      if (index == 0) {
        this.getOrderList(-5);
      }
      if (index == 1) {
        this.getOrderList(-6);
      }
      if (index == 2) {
        this.getOrderList(-7);
      }
      if (index == 3) {
        this.getOrderList(-8);
      }
    },
    getOrderList(orderSatus) {
      equOrderListS({
        pageSize: 7,
        orderSatus: orderSatus,
        superType: -3,
      }).then((res) => {
        this.tableData = res.rows;
      });
    },
    getOrderLists() {
      // equOrderListSs().then((res) => {
      //   console.log(res);
      //   this.datas = res;
      // });
        staApiAll({
            type:"pczhongxin",
            startTime:new Date(new Date().setMonth(new Date().getMonth()-3)).getFullYear() +
                '-' +(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1<10?
                    '0'+(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1):
                    (new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1))+
                "-" + new Date(new Date().setMonth(new Date().getMonth()-3)).getDate(),
            endTime:new Date().getFullYear() + '-' +(new Date().getMonth()+1<10?'0'+(new Date().getMonth()+1):(new Date().getMonth()+1))+ "-" + new Date().getDate()
        }).then((res)=>{
          this.datas=res
      })
    },
    hanldeCheck(row) {
      if (row.orderType == 1) {
        //应急保电
        this.$router.push({
          path: "/factoryUser/factoryDetailEme",
          query: {
            id: row.id,
          },
        });
      } else {
        //0 成套设备
        this.$router.push({
          path: "/factoryUser/factoryDetailEqu",
          query: {
            id: row.id,
          },
        });
      }
    },
  },
  created: function() {
    //生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
    this.getRegion();
    this.getUserInfo();
    this.getOrderList(-5);
    this.getOrderList1();
    this.getOrderLists();
  },
};
</script>

<style lang="less" scoped="scoped">
.uploadCss {
  .avatar-uploader-icon[data-v-266d29ce] {
    border: 1px dashed #d9d9d9;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}

.mine {
  width: 100%;
}

.title {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid @vue-border-color;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  .name {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .padding {
    width: 4px;
    height: 16px;
    background: #ff5252;
    margin-right: @vue-spacing-row-sm;
  }
}

.top {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .info,
  .bill {
    width: 49%;
  }

  .info {
    padding: 0px @vue-spacing-row-sm;
    box-sizing: border-box;
    background: @vue-bg-color;
  }

  .company-info {
    width: 100%;

    .company-avatar {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .avatar {
        width: 60px;
        height: 60px;
        border-radius: @vue-border-radius-circle;
        overflow: hidden;

        .avatar-uploader .el-upload {
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 60px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          border: 1px dashed #d9d9d9;
          border-radius: @vue-border-radius-circle;
          box-sizing: border-box;
        }

        .avatar-uploader-icon:hover {
          border-color: #409eff;
        }

        .image-area {
          width: 60px;
          height: 60px;
          position: relative;
          border-radius: @vue-border-radius-circle;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            display: block;
          }
          .avatar {
            width: 60px;
            height: 60px;
            border-radius: @vue-border-radius-circle;
            overflow: hidden;}

          span {
            width: 100%;
            height: 20px;
            position: absolute;
            left: 0px;
            bottom: 0px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: @vue-font-size-sm - 2;
            color: @vue-text-color-inverse;
            background: @vue-bg-color-mask;
          }
        }
      }

      .right {
        width: calc(100% - 80px);
        height: 100%;
        padding: 20px 0px;
        box-sizing: border-box;

        .username,
        .score {
          width: 100%;
          height: 50%;
          display: flex;
          align-items: center;
        }

        .username {
          font-size: 15px;
          font-weight: 700;
        }
      }
    }
  }

  .bill {
    .title {
      padding: 0px @vue-spacing-row-sm;
      box-sizing: border-box;
      background: @vue-bg-color;
    }
  }

  .money {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px @vue-spacing-row-sm;
    box-sizing: border-box;
    background: @vue-bg-color;

    .item {
      width: 33.3%;
      border-right: 1px solid @vue-border-color;

      .value {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ff5252;
        font-size: @vue-font-size-base;
        font-weight: bold;
      }

      .key {
        width: 100%;
        height: 20px;
        display: flex;
        justify-content: center;
        font-size: @vue-font-size-sm - 2;
      }
    }

    .item:last-child {
      border: none;
    }
  }

  .list {
    width: 100%;
    margin-top: @vue-spacing-col-sm;
    background: @vue-bg-color;
    min-height: 440px;

    .tabbar {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      border: 1px solid @vue-border-color;
      border-left: none;
      border-right: none;
      background: @vue-bg-color-grey;

      .item {
        width: 33%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: @vue-font-size-sm - 2;
        cursor: pointer;
      }

      .item-select {
        background: #999999;
        color: @vue-text-color-inverse;
      }
    }

    .table {
      width: 100%;
      padding: 0px @vue-spacing-row-sm;
      box-sizing: border-box;
    }

    .pager {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0px @vue-spacing-row-sm;
      box-sizing: border-box;
      background: @vue-bg-color;
    }
  }
}

.btm {
  width: 100%;
  margin-top: @vue-spacing-col-lg;
  padding: 0px @vue-spacing-row-sm @vue-spacing-col-lg @vue-spacing-row-sm;
  box-sizing: border-box;
  background: @vue-bg-color;

  .box {
    width: 100%;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item {
      width: 48%;
      height: 120px;
      background: @vue-bg-color-grey;
      padding: @vue-spacing-col-lg @vue-spacing-row-lg;
      box-sizing: border-box;

      .key,
      .value {
        width: 100%;
        height: 40%;
        display: flex;
        align-items: center;
      }

      .key {
        font-size: @vue-font-size-sm + 4;
        font-weight: bold;
      }

      .value {
        font-size: @vue-font-size-sm - 2;
        color: @vue-text-color-grey;
      }
    }
  }
}
</style>
